import axios from 'lib/axios'

function flagsUrl(packageHashedId) {
  return `/api/packages/${packageHashedId}/flags`
}

export function getFlags(packageHashedId) {
  return axios.get(flagsUrl(packageHashedId))
}

export function createFlag(packageHashedId, { flaggableType, flaggableId, reason }) {
  return axios.post(flagsUrl(packageHashedId), { flaggable_type: flaggableType, flaggable_id: flaggableId, reason })
}

export function updateFlag(packageHashedId, flagId, { reason }) {
  return axios.patch(`${flagsUrl(packageHashedId)}/${flagId}`, { flag: { reason } })
}

export function deleteFlag(packageHashedId, flagId) {
  return axios.delete(`${flagsUrl(packageHashedId)}/${flagId}`)
}

export function markFixedFlag(packageHashedId, flagId) {
  return axios.patch(`${flagsUrl(packageHashedId)}/${flagId}/mark_fixed`)
}

export function markUnfixedFlag(packageHashedId, flagId) {
  return axios.patch(`${flagsUrl(packageHashedId)}/${flagId}/undo`)
}

export function acceptFlag(packageHashedId, flagId) {
  return axios.patch(`${flagsUrl(packageHashedId)}/${flagId}/accept`)
}

export function rejectFlag(packageHashedId, flagId) {
  return axios.patch(`${flagsUrl(packageHashedId)}/${flagId}/undo`)
}

export function undeleteFlag(packageHashedId, flagId) {
  return axios.patch(`${flagsUrl(packageHashedId)}/${flagId}/undelete`)
}

export function getAcknowledgementResponse(packageId) {
  return axios.get(`/api/packages/${packageId}/rounds/acknowledgement_response`)
}

export function reSendAcknowledgementResponse(packageId) {
  return axios.post(`/api/packages/${packageId}/rounds/resend_acknowledgement_response`)
}

export function finalizeRound(packageId) {
  return axios.post(`/api/packages/${packageId}/rounds/finalize`)
}

export function getFinalizationStatus(packageId) {
  return axios.get(`/api/packages/${packageId}/rounds/finalization_status`)
}
